import React, { useContext, useMemo } from 'react';
import { Typography, Layout, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { UserContext } from 'src/utils/UserContext';
import { deleteToken } from 'src/services';
import userIcon from '../assets/images/userIcon.svg';

const { Title, Text } = Typography;

type SiderProps = {
    isAdmin: boolean;
    setIsAuth?: (authenticated: boolean) => void;
};

type Links = {
    key: string;
    name: string;
    link: string;
};

type LinksMapper = {
    customerLinks: Links[];
    adminLinks: Links[];
};

function Sider({ isAdmin, setIsAuth }: SiderProps): JSX.Element {
    const userContext = useContext(UserContext);

    const handleClick = () => {
        setIsAuth?.(false);
        deleteToken();
    };

    const links: LinksMapper = {
        customerLinks: [
            {
                key: 'dashboard',
                name: 'Dashboard',
                link: '/',
            },
            {
                key: 'messages',
                name: 'Messages',
                link: 'messages',
            },
            {
                key: 'settings',
                name: 'Settings',
                link: 'settings',
            },
        ],
        adminLinks: [
            {
                key: 'dashboard',
                name: 'Dashboard',
                link: '/',
            },
            {
                key: 'messages',
                name: 'Messages',
                link: 'messages',
            },
            {
                key: 'accounts',
                name: 'Accounts',
                link: 'accounts',
            },
            {
                key: 'archives',
                name: 'Archives',
                link: 'archives',
            },
            {
                key: 'settings',
                name: 'Settings',
                link: 'settings',
            },
        ],
    };

    return (
        <Row className="sider" style={{ background: '#C9E0C9' }}>
            <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                style={{
                    marginTop: '0px',
                    paddingTop: '20px',
                    paddingBottom: '20px',
                    padding: '5px',
                    height: '100%',
                    background: '#ffffff',
                    borderRadius: '25px',
                }}
            >
                <Row className="row" style={{ padding: '10px', marginTop: '10px' }}>
                    <Col span={24}>
                        <Row className="ant-layout-flex-left" style={{ display: 'flex' }}>
                          <Col>
                                <img
                                    className="profile-photo-header"
                                    src={userContext?.userState?.photo || userIcon}
                                    alt=""
                                    style={{ height: '50px', width: '50px', borderRadius: '50%' }}
                                />
                            </Col>
                            <Col style={{marginLeft:'5px', marginTop:'7px'}}>
                                <Title style={{ fontSize: '15px', color: '#0b543e', marginBottom: '0px' }}>
                                    Account Name
                                </Title>
                                <Text style={{ fontSize: '14px', marginTop: '0px', color: '#ef976e' }}>
                                    {userContext?.userState?.firstName}&nbsp;{userContext?.userState?.lastName}
                                </Text>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className="row" style={{ padding: '10px'}}>
                    {links[isAdmin ? 'adminLinks' : 'customerLinks'].map((link) => (
                        <Col span={24} style={{ textAlign: 'left', paddingLeft: '10px', marginTop: '15px' }}>
                            <Link to={link.link} key={link.key}>
                                <Text className="link row text" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                    {link.name}
                                </Text>
                            </Link>
                        </Col>
                    ))}
                </Row>

                <Row className="row show-on-mobile-only" style={{ padding: '10px', marginTop: '0px' }}>
                    <Col span={24} style={{ textAlign: 'left', paddingLeft: '10px', marginTop: '5px' }}>
                        <Link to="/" onClick={handleClick}>
                            <Text className="link row text" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                Logout
                            </Text>
                        </Link>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default Sider;
